/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, useRef } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import { getUserByToken, register } from '../core/_requests'
import { Link, useNavigate } from 'react-router-dom'
import { PasswordMeterComponent } from '../../../../_metronic/assets/ts/components'
import { useAuth } from '../core/Auth'
import { showError, showSuccess } from '../../../../_mel/customPartials/helper/Alerts'
import { useIntl } from 'react-intl'
import { Card, Modal } from 'antd'
import Codes from '../../base-definitions/components/code/PredefinedCodes'
import { useDispatch, useSelector } from 'react-redux'
import { fetchKvkk } from '../../../../_redux/features/kvkk/kvkkSlice'
import { getTenantConfig } from '../../../configs/tenantconfig'
import { WorkExperienceCard, WorkExperienceCardRef } from './WorkExperienceCard'
import { fetchIndustries, fetchJobLevels, fetchWorkExperienceTypes } from '../../../../_redux/features/work-experience/workExperienceSlice'

const initialValues = {
  name: '',
  surname: '',
  emailAddress: '',
  tc: '',
  fatherName: '',
  password: '',
  birthDate: '',
  changepassword: '',
  graduateDate: '',
  phoneNumber: '', 
  kvkkChecked : false,
  isWorking: false
}

const flagCss: React.CSSProperties = { width: '2.5rem', aspectRatio: '3/2', overflow: 'hidden', objectFit: 'cover', objectPosition: 'center', cursor: 'pointer' };

export function Registration({ setLocale }) {
  const intl = useIntl();
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const { saveAuth, setCurrentUser } = useAuth()
  const [modalVisible, setModalVisible] = useState(false);
  
  const dispatch = useDispatch<any>()
  const childRef = useRef<WorkExperienceCardRef>(null);

  const { hr_info } = getTenantConfig();
  const {kvkk} = useSelector((state: any) => state.kvkk)
  const [workModalVisible, setWorkModalVisible] = useState(false);

    const { industries, jobLevels, workExperienceTypes } = useSelector((state: any) => state.workExperience)

  useEffect(() => { 
    dispatch(fetchKvkk({ id : Codes.KvkkRegistration }))
    
    dispatch(fetchIndustries())
    dispatch(fetchJobLevels())
    dispatch(fetchWorkExperienceTypes())
  }, [])
  const handleKvkkClicked = () => {
    setModalVisible(true)
  };
  const handleModalClose = () => {
      setModalVisible(false);
  };

  const registrationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, intl.formatMessage({ id: 'AUTH.ERROR.MIN3' }))
      .max(50, intl.formatMessage({ id: 'AUTH.ERROR.MAX50' }))
      .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRDFIELD' })),
    surname: Yup.string()
      .min(3, intl.formatMessage({ id: 'AUTH.ERROR.MIN3' }))
      .max(50, intl.formatMessage({ id: 'AUTH.ERROR.MAX50' }))
      .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRDFIELD' })),
    emailAddress: Yup.string()
      .email('Wrong email format')
      .min(3, intl.formatMessage({ id: 'AUTH.ERROR.MIN3' }))
      .max(50, intl.formatMessage({ id: 'AUTH.ERROR.MAX50' }))
      .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRDFIELD' })),
    password: Yup.string()
      .min(3, intl.formatMessage({ id: 'AUTH.ERROR.MIN3' }))
      .max(50, intl.formatMessage({ id: 'AUTH.ERROR.MAX50' }))
      .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRDFIELD' })),
    tc: Yup.string()
      .matches(/^\d{11}$/, 'TC Identity Number must be exactly 11 digits')
      .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRDFIELD' })),
    fatherName: Yup.string()
      .min(3, intl.formatMessage({ id: 'AUTH.ERROR.MIN3' }))
      .max(50, intl.formatMessage({ id: 'AUTH.ERROR.MAX50' }))
      .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRDFIELD' })),
    birthDate: Yup.date()
      .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRDFIELD' }))
      .typeError('Invalid date format'),
    graduateDate: Yup.date()
      .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRDFIELD' }))
      .typeError('Invalid date format'),
    changepassword: Yup.string()
      .min(3, intl.formatMessage({ id: 'AUTH.ERROR.MIN3' }))
      .max(50, intl.formatMessage({ id: 'AUTH.ERROR.MAX50' }))
      .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRDFIELD' }))
      .oneOf([Yup.ref('password')], intl.formatMessage({ id: 'AUTH.ERROR.PASSWORDNOTMATCH' })),
    phoneNumber: Yup.string()
    .required(intl.formatMessage({ id: 'AUTH.ERROR.REQUIRDFIELD' }))
    .matches(/^[5]\d{9}$/, intl.formatMessage({ id: 'AUTH.PHONENUMBER.INCORRECT' })),
    kvkkChecked: Yup.boolean()
      .oneOf([true], intl.formatMessage({ id: 'AUTH.ERROR.ACCEPTTERMS' }))
  })
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        const fullPhoneNumber = "+90" + values.phoneNumber;
        
        var workExperience : object | undefined = undefined;
        
        if (values.isWorking == true ){
           workExperience = await childRef.current?.validateAndGetValues();
        }
        //console.log(values, jobExp)
        await register(
          values.emailAddress,
          values.name,
          values.surname,
          values.password,
          values.fatherName,
          values.tc,
          fullPhoneNumber,
          //values.phoneNumber,
          values.birthDate,
          values.graduateDate,
          intl.locale ?? "tr-TR",
          workExperience
        )
          .then((res: any) => {

            if (res.data?.result?.canLogin) {
              showSuccess(res.data?.result?.message ?? intl.formatMessage({ id: 'AUTH.REGISTER.SUCCESS.REDIRECTING' }));
              setTimeout(() => {
                navigate('/auth')
              }, 1000);
            }
            else {
              setLoading(false)

              let message = res.data?.result?.message ?? "Unnown Error occured! / Bilinmeyen bir hata oluştu!";
              showError(message)
            }
          })
          .catch((err: any) => {
            setLoading(false)
            let message = err?.response?.data?.error?.message ?? "Unnown Error occured! / Bilinmeyen bir hata oluştu!";
            showError(message)
          })
        // saveAuth(auth)
        // const {data: user} = await getUserByToken()
        // setCurrentUser(user)
      } catch (error: any) {
        let message = error?.response?.data?.error?.message ?? "Unnown Error occured! / Bilinmeyen bir hata oluştu!";
        showError(message)
        saveAuth(undefined)
        setStatus('The registration details is incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])

  return (
    <Card className="card-container shadow-lg" >
      <div className="flags" style={{ position: 'absolute', top: '0.5rem', right: '0.5rem', display: 'flex', gap: '5px', zIndex: '10' }}>
        <img className="rounded-1" src="/media/flags/turkey.svg" alt="Turkish" onClick={() => setLocale('tr')}
          style={flagCss} />
        <img className="rounded-1" src="/media/flags/united-states.svg" alt="English" onClick={() => setLocale('en')}
          style={flagCss} />
      </div>

      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework pt-10'
        noValidate
        id='kt_login_signup_form'
        onSubmit={formik.handleSubmit}
      >
        {/* begin::Heading */}
        <div className='text-center mb-11'>
          {/* begin::Title */}
          <h1 className='text-dark fw-bolder mb-3'>{intl.formatMessage({ id: 'AUTH.SIGNUP' })}</h1>
          {/* end::Title */}

          {/* <div className='text-gray-500 fw-semibold fs-6'>Your Social Campaigns</div> */}
        </div>
        {formik.status && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status}</div>
          </div>
        )}
        {/* begin::Form group Firstname */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'AUTH.FIRSTNAME' })}</label>
          <input
            placeholder={intl.formatMessage({ id: 'AUTH.FIRSTNAME' })}
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('name')}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.name && formik.errors.name,
              },
              {
                'is-valid': formik.touched.name && !formik.errors.name,
              }
            )}
          />
          {formik.touched.name && formik.errors.name && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.name}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}
        <div className='fv-row mb-8'>
          {/* begin::Form group Lastname */}
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'AUTH.LASTNAME' })}</label>
          <input
            placeholder={intl.formatMessage({ id: 'AUTH.LASTNAME' })}
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('surname')}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.surname && formik.errors.surname,
              },
              {
                'is-valid': formik.touched.surname && !formik.errors.surname,
              }
            )}
          />
          {formik.touched.surname && formik.errors.surname && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.surname}</span>
              </div>
            </div>
          )}
          {/* end::Form group */}
        </div>
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'AUTH.EMAILNAME' })}</label>
          <input
            placeholder={intl.formatMessage({ id: 'AUTH.EMAILNAME' })}
            type='email'
            autoComplete='off'
            {...formik.getFieldProps('emailAddress')}
            className={clsx(
              'form-control bg-transparent',
              { 'is-invalid': formik.touched.emailAddress && formik.errors.emailAddress },
              {
                'is-valid': formik.touched.emailAddress && !formik.errors.emailAddress,
              }
            )}
          />
          {formik.touched.emailAddress && formik.errors.emailAddress && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.emailAddress}</span>
              </div>
            </div>
          )}
        </div>
        <div className='fv-row mb-8'>
          {/* begin::Form group Fathername */}
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'AUTH.TURKISHIDENTITY' })}</label>
          <input
            placeholder={intl.formatMessage({ id: 'AUTH.TURKISHIDENTITY' })}
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('tc')}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.tc && formik.errors.tc,
              },
              {
                'is-valid': formik.touched.tc && !formik.errors.tc,
              }
            )}
          />
          {formik.touched.tc && formik.errors.tc && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.tc}</span>
              </div>
            </div>
          )}
          {/* end::Form group */}
        </div>
        
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'AUTH.PHONENUMBER' })}</label>
          
          <div className="input-group">
            {/* Sol taraftaki +90 Alanı */}
            <span className="input-group-text border-0" style={{backgroundColor: '#f5f8fa'}}>
               <img src="/media/flags/turkey.svg" alt="TR" className="w-20px me-2" />
               <span className="fw-bold text-gray-600 fs-7">+90</span>
            </span>

            {/* Kullanıcının Sayı Girdiği Alan */}
            <input
              placeholder="5XX XXX XX XX"
              type='tel'
              maxLength={10} // 10 haneden fazla girmesin
              autoComplete='off'
              {...formik.getFieldProps('phoneNumber')}
              className={clsx(
                'form-control bg-transparent',
                {
                  'is-invalid': formik.touched.phoneNumber && formik.errors.phoneNumber,
                },
                {
                  'is-valid': formik.touched.phoneNumber && !formik.errors.phoneNumber,
                }
              )}
              // Kullanıcı sadece sayı girebilsin diye ufak bir koruma:
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </div>
          
          {/* Hata Mesajı Gösterimi */}
          {formik.touched.phoneNumber && formik.errors.phoneNumber && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.phoneNumber}</span>
              </div>
            </div>
          )}
          
          <div className="form-text text-muted">
             {/* Kullanıcıya ipucu vermek istersen opsiyonel */}
             Lütfen başında 0 olmadan giriniz (Örn: 532XXXXXXX)
          </div>
        </div>

        <div className='fv-row mb-8'>
          {/* begin::Form group Fathername */}
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'AUTH.FATHERNAME' })}</label>
          <input
            placeholder={intl.formatMessage({ id: 'AUTH.FATHERNAME' })}
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('fatherName')}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.fatherName && formik.errors.fatherName,
              },
              {
                'is-valid': formik.touched.fatherName && !formik.errors.fatherName,
              }
            )}
          />
          {formik.touched.fatherName && formik.errors.fatherName && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.fatherName}</span>
              </div>
            </div>
          )}
        </div>
        <div className='fv-row mb-8'>
          {/* begin::Form group Fathername */}
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'AUTH.BIRTHDATE' })}</label>
          <input
            placeholder={intl.formatMessage({ id: 'AUTH.BIRTHDATE' })}
            type='date'
            autoComplete='off'
            {...formik.getFieldProps('birthDate')}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.birthDate && formik.errors.birthDate,
              },
              {
                'is-valid': formik.touched.birthDate && !formik.errors.birthDate,
              }
            )}
          />
          {formik.touched.birthDate && formik.errors.birthDate && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.birthDate}</span>
              </div>
            </div>
          )}
          {/* end::Form group */}
        </div>
        <div className='fv-row mb-8'>
          {/* begin::Form group Fathername */}
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'AUTH.GRADUATEDATE' })}</label>
          <input
            placeholder={intl.formatMessage({ id: 'AUTH.GRADUATEDATE' })}
            type='date'
            autoComplete='off'
            {...formik.getFieldProps('graduateDate')}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.graduateDate && formik.errors.graduateDate,
              },
              {
                'is-valid': formik.touched.graduateDate && !formik.errors.graduateDate,
              }
            )}
          />
          {formik.touched.graduateDate && formik.errors.graduateDate && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.graduateDate}</span>
              </div>
            </div>
          )}
          {/* end::Form group */}
        </div>
        {/* ÇALIŞIYOR MUSUNUZ CHECKBOX */}
        <div className="form-item pb-4 mt-4">
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'WORKEXPERIENCE.DOYOUHAVEWORKINGEXP' })}</label>
          <div className="checkbox-container">
            <input
              type="checkbox"
              id="isWorking"
              checked={formik.values.isWorking}
              {...formik.getFieldProps('isWorking')}
              onChange={(e) => {
                formik.handleChange(e); // Formik state'ini güncelle
                if (e.target.checked) {
                  setWorkModalVisible(true); // Tiklenince modalı aç
                } else {
                  setWorkModalVisible(false);
                }
              }}
            />
          <label 
              htmlFor="isWorking" 
              className='ps-2' 
              style={{ userSelect: 'none', cursor: 'pointer' }}
            >
              {intl.formatMessage({ id: 'WORKEXPERIENCE.IHAVEWORKINGEXP' })}
            </label>
          </div>
        </div>
        <WorkExperienceCard
            intl={intl}
            visible={workModalVisible}
            dispatch={dispatch}
            industries={industries}
            jobLevels={jobLevels} 
            workExperienceTypes={workExperienceTypes}
            ref={childRef}
          />
        {/* begin::Form group Password */}
        <div className='fv-row mb-8' data-kt-password-meter='true'>
          <div className='mb-1'>
            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'AUTH.PASSWORD' })}</label>
            <div className='position-relative mb-3'>
              <input
                type='password'
                placeholder={intl.formatMessage({ id: 'AUTH.PASSWORD' })}
                autoComplete='off'
                {...formik.getFieldProps('password')}
                className={clsx(
                  'form-control bg-transparent',
                  {
                    'is-invalid': formik.touched.password && formik.errors.password,
                  },
                  {
                    'is-valid': formik.touched.password && !formik.errors.password,
                  }
                )}
              />
              {formik.touched.password && formik.errors.password && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.password}</span>
                  </div>
                </div>
              )}
            </div>
            {/* begin::Meter */}
            <div
              className='d-flex align-items-center mb-3'
              data-kt-password-meter-control='highlight'
            >
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
            </div>
            {/* end::Meter */}
          </div>
          <div className='text-muted'>
            {intl.formatMessage({ id: 'AUTH.PASWORDINFO' })}
          </div>
        </div>
        {/* end::Form group */}
        {/* begin::Form group Confirm password */}
        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'AUTH.CONFIRMPASSWORD' })}</label>
          <input
            type='password'
            placeholder={intl.formatMessage({ id: 'AUTH.CONFIRMPASSWORD' })}
            autoComplete='off'
            {...formik.getFieldProps('changepassword')}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
              },
              {
                'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
              }
            )}
          />
          {formik.touched.changepassword && formik.errors.changepassword && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.changepassword}</span>
              </div>
            </div>
          )}
        </div>
        <div className="form-item pb-4">
          <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'PDPL.CHECK' })}</label>
          <div className="checkbox-container">
            <input
              type="checkbox"
              id="kvkkChecked"
              {...formik.getFieldProps('kvkkChecked')}
              //onChange={handleKVKKCheckBoxChange}
            />
            <span className='ps-2'>
              <span
                style={{ color: 'blue', cursor: 'pointer' }}
                onClick={handleKvkkClicked}
              >
                {intl.formatMessage({ id: 'PDPL.CHECK.HIGHLIGHT' })}
              </span>
              {intl.formatMessage({ id: 'PDPL.CHECK.TEXT' })}
            </span>
            {formik.touched.kvkkChecked && formik.errors.kvkkChecked && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.kvkkChecked}</span>
              </div>
            </div>
          )}
          </div>
        </div>
        {hr_info && (
              
        <div className='form-item'>
          <div 
            className='text-gray-700 text-center fw-semibold fs-6 py-2 my-2'  
            style={{ border: "1px solid #bfbfbf", backgroundColor: "#f8f8f8", borderRadius : "9px"}}>
              {intl.formatMessage({id: 'AUTH.INFO_FOR_HR'})}
          </div>
        </div>
        )}
        {/* begin::Form group */}
        <div className='text-center'>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-lg btn-primary w-100 mb-5'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label'>{intl.formatMessage({ id: 'AUTH.SUBMIT' })}</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                {intl.formatMessage({ id: 'AUTH.PLEASEWAIT' })}{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_signup_form_cancel_button'
              className='btn btn-lg btn-light-primary w-100 mb-5'
            >
              {intl.formatMessage({ id: 'AUTH.CANCEL' })}
            </button>
          </Link>
          <Modal
                title="KVKK METNİ"
                open={modalVisible}
                onCancel={handleModalClose}
                okButtonProps={{ style: { display: 'none' } }}
                cancelText={intl.formatMessage({ id: 'BUTTON.CANCEL' })}
            >
                <div dangerouslySetInnerHTML={{ __html: kvkk?.body??"" }} />
            </Modal>
        </div>
        {/* end::Form group */}
      </form>
    </Card>
  )
}
